import { render, staticRenderFns } from "./ComissionGroup.vue?vue&type=template&id=998a85b8"
import script from "./ComissionGroup.vue?vue&type=script&lang=js"
export * from "./ComissionGroup.vue?vue&type=script&lang=js"
import style0 from "./ComissionGroup.vue?vue&type=style&index=0&id=998a85b8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpace from 'quasar/src/components/space/QSpace.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QDialog,QCardSection,QInput,QCardActions,QBtn,QSpace});qInstall(component, 'directives', {ClosePopup});
